import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import GroupsIcon from '@mui/icons-material/Groups';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useCookies } from "react-cookie";
import axios from "axios";
import { useDispatch } from 'react-redux';
import { setAllDataOfContact } from '../../Redux/Index';
import SearchIcon from '@mui/icons-material/Search';
import { connect } from 'react-redux';
import { fetchAllDataOfContact } from '../../Utility/FetchAllData/FetchAllData';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import { verifyCookie } from '../../Utility/VerifyCookie/VerifyCookie';
import cusStyles from './Dashboard.module.css'
import SessionAndStoreReset from '../SessionAndStoreReset/SessionAndStoreReset';
import { passwordChangeHandleChangeFunc } from '../PasswordChange/PasswordChangeHandleChangeFunc';
import { passwordChangeSubmitFunc } from '../PasswordChange/PasswordChangeSubmitFunc';
import PasswordChangeUi from '../PasswordChange/PasswordChangeUi';
import ClearIcon from '@mui/icons-material/Clear';

// Redux func start

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact
  }
}

const mapDispatchToPropsForAllData = dispatch => {
  return {
    SET_ALL_DATA_OF_CONTACT_STATE: (allDataOfContactValue) => dispatch(setAllDataOfContact(allDataOfContactValue))
  }
}

// Redux func end

// Theme and hamburger func start

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const defaultTheme = createTheme();

// Theme and hamburger func end

sessionStorage.setItem("GdEGeSTESGEt2ERgsdf34GEEr", "sGsdkE34GseGHrSDX2F");

function Dashboard( { allDataOfContact, children } ) {  

  let currentPasswordErrorState = false;
  let newPasswordErrorState = false;
  let reNewPasswordErrorState = false;
  let overAllError = false;
  let currentPasswordErrorMessage = "";
  let newPasswordErrorMessage = "";
  let reNewPasswordErrorMessage = "";
  let overAllErrorMessage = "";


  const [searchTerm, setSearchTerm] = useState("");
  const [gotData, setGotData] = useState(false);
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [errorFromServer, setErrorFromServer] = useState("");
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const [isFormSubmitButtonClicked, setIsFormSubmitButtonClicked] = useState(false);
  const [changePasswordVal, setChangePasswordVal] = useState({
    currentPassword: "",
    newPassword: "",
    reNewPassword: ""
  });

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  const toggleDrawer = () => {
    setOpen(!open);
  };

  const dispatch = useDispatch();


        var currentPageUrl = window.location.href;
        var urlParts = currentPageUrl.split('/');

        var urlSearchParams = "";
        if (urlParts.length >= 3) {
          if(urlParts[3] != "LeadDetail" && urlParts[3] != "OpportunityDetail" && urlParts[3] != "CaseDetail" && urlParts[3] != "NewCaseResult") {
          urlSearchParams = urlParts[4];
          }
          if(urlSearchParams) {
              urlSearchParams = urlSearchParams.replace(/%20/g, ' ');
          } else {
            urlSearchParams = "";
          }
        } else {
          console.log("Not enough parts in the URL");
        }

  const navigate = useNavigate();
  const [cookies, removeCookie] = useCookies([]);
  useEffect(() => {
    verifyCookie(cookies, navigate);

    if(gotData == false && (sessionStorage.getItem("GdEGeSTESGEt2ERgsdf34GEEr") && sessionStorage.getItem("GdEGeSTESGEt2ERgsdf34GEEr") == "sGsdkE34GseGHrSDX2F")) {

      loginTimeOutAndRedirectHandler(fetchAllDataOfContact, "", dispatch, setAllDataOfContact, navigate, "/", "", "", "", setGotData);
    }

  }, [cookies, navigate, removeCookie, dispatch, gotData]);
  
  // Logout func start

  const Logout = async () => {
    const logoutData  = await axios.post(
      "https://salesforceb2b.customers.bigfivecrm.com/logout",
      {},
      { withCredentials: true }
    );
    
    SessionAndStoreReset(dispatch, setAllDataOfContact, setGotData, navigate, "/");
  };

  // Logout func end

  // Search func start

  function searchTheKeyword() {
    if(searchTerm != "" && searchTerm != " " && searchTerm != "   ") {
      navigate(`/Search/${searchTerm}`);
    }
  }

  function clearTheSearchKeyword() {
    setSearchTerm("");
  }

  // Search func end

  // Call for password change functionality start
  const handleOnChange = (e) => {
    passwordChangeHandleChangeFunc(e, setErrorFromServer, setChangePasswordVal, changePasswordVal);    
  };

  const {currentPassword, newPassword, reNewPassword } = changePasswordVal;

  // Password value verification func start 

  if(isFormSubmitButtonClicked) {

    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.*[a-zA-Z0-9@#$%^&+=!]).{8,}$/;

    if (!currentPassword) {
      currentPasswordErrorState = true;
      currentPasswordErrorMessage = "Please enter the current password!";
    } else if (!currentPassword.match(passwordPattern)) {
      currentPasswordErrorState = true;
      currentPasswordErrorMessage = "Password is doesn't match the pattern!";
    } else {
      currentPasswordErrorState = false;
      currentPasswordErrorMessage = "";
    }

    if (!newPassword) {
      newPasswordErrorState = true;
      newPasswordErrorMessage = "Please enter the new password!";
    } else if (!newPassword.match(passwordPattern)) {
      newPasswordErrorState = true;
      newPasswordErrorMessage = "New password is doesn't match the pattern!";
    } else {
      newPasswordErrorState = false;
      newPasswordErrorMessage = "";
    }

    if (!reNewPassword) {
      reNewPasswordErrorState = true;
      reNewPasswordErrorMessage = "Please reenter the new password!";
    } else if (!reNewPassword.match(passwordPattern)) {
      reNewPasswordErrorState = true;
      reNewPasswordErrorMessage = "Reentered new password is doesn't match the pattern!";
    } else {
      reNewPasswordErrorState = false;
      reNewPasswordErrorMessage = "";
    }

    overAllError = false;
    overAllErrorMessage = "";

    if(currentPassword == newPassword) {
      if(currentPassword != "" && newPassword != "") {
      overAllError = true;
      overAllErrorMessage = "Current and new passwords are same!";
      }
    }

    if(newPassword != reNewPassword) {
      overAllError = true;
      overAllErrorMessage = "New and reentered passwords are not same!";
    }

  }

  // Password value verification func end

  const handleSubmit = async(e) => {
    await passwordChangeSubmitFunc(e, setIsFormSubmitButtonClicked, isFormSubmitButtonClicked, currentPasswordErrorState, newPasswordErrorState, reNewPasswordErrorState, setIsFormSubmitted, changePasswordVal, setErrorFromServer, setChangePasswordVal, setIsPopupOpened);
  }

  // Call for password change functionality end
    
  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px',
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'left', display: { xs: 'none', sm: 'inline-block'} }}
            >
              <Link to="/Dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>
              Dashboard
              </Link>
            </Typography>
            <div style={{ display: 'flex', height: '35px', width: '500px', backgroundColor: 'white', borderRadius: '5px', padding: '5px' }}>
                <input type="text" style={{ width: '100%', border: 'none', outline: 'none', padding: '10px', borderRadius: '5px 0px 0px 5px' }} placeholder="Search..." value={searchTerm == "" ? (urlSearchParams != "" ? "" : "") : searchTerm} onChange={(e) => { setSearchTerm(e.target.value) }} />
                { searchTerm != "" ? <div style={{ padding: '1.5px', borderRadius: '5px 5px 5px 5px', cursor: "pointer" }} ><ClearIcon className={cusStyles.searchClearBtn} onClick={clearTheSearchKeyword} style={{ fontSize: "12px" }} /></div> : "" }
                <div style={{ padding: '1.5px', borderRadius: '5px 5px 5px 5px', cursor: "pointer" }} ><SearchIcon className={cusStyles.searchBtn} onClick={searchTheKeyword} /></div>
            </div>
            <IconButton color="inherit" onClick={handleMenu} >
              <AccountCircleIcon style={{ height: '40px', width: '40px' }}></AccountCircleIcon>
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem><Link to="/Contacts" style={{ color: "inherit", textDecoration: "none" }}>My Profile</Link></MenuItem>
                <MenuItem><Link to="/Accounts" style={{ color: "inherit", textDecoration: "none" }}>My Account</Link></MenuItem>
                <MenuItem onClick={() => {setIsPopupOpened(true); handleClose();}}>Change Password</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List component="nav">
          <Link to="/Cases" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton title={ open == false ? 'Cases' : '' }>
            <ListItemIcon>
              <SupportAgentIcon />
            </ListItemIcon>
            <ListItemText primary="Cases"/>
          </ListItemButton>
          </Link>
          <Link to="/Leads" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton title={ open == false ? 'Leads' : '' }>
            <ListItemIcon>
              <GroupsIcon />
            </ListItemIcon>
            <ListItemText primary="Leads"/>
          </ListItemButton>
          </Link>
          <Link to="/Opportunities" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton title={ open == false ? 'Opportunities' : '' }>
            <ListItemIcon>
              <TipsAndUpdatesIcon />
            </ListItemIcon>
            <ListItemText primary="Opportunities"/>
          </ListItemButton>
          </Link>
          <ListItemButton title={ open == false ? 'Logout' : '' } onClick={Logout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout"/>
          </ListItemButton>
            <Divider sx={{ my: 1 }} />
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Toolbar />
          { children }
        </Box>
      </Box>
      {/* Change password popup start */}
      <PasswordChangeUi isPopupOpened={isPopupOpened} currentPassword={currentPassword} currentPasswordErrorState={currentPasswordErrorState} currentPasswordErrorMessage={currentPasswordErrorMessage} handleOnChange={handleOnChange} newPassword={newPassword} newPasswordErrorState={newPasswordErrorState} newPasswordErrorMessage={newPasswordErrorMessage} reNewPassword={reNewPassword} reNewPasswordErrorState={reNewPasswordErrorState} reNewPasswordErrorMessage={reNewPasswordErrorMessage} overAllError={overAllError} isFormSubmitButtonClicked={isFormSubmitButtonClicked} overAllErrorMessage={overAllErrorMessage} errorFromServer={errorFromServer} setIsPopupOpened={setIsPopupOpened} handleSubmit={handleSubmit} isFormSubmitted={isFormSubmitted} />
      {/* Change password popup end */}
    </ThemeProvider>
  );
                
}

export default connect(mapStateToPropsForAllData, mapDispatchToPropsForAllData)(Dashboard);

